export const TreatmentSummaryBar = {
  flow: 'x',
  align: 'center space-between',
  padding: 'A B',
  background: 'inkMid',
  borderTop: '1px solid inkBorder',
  position: 'sticky',
  bottom: '0',
  zIndex: '10',
  gap: 'B',
  '@mobileL': { flow: 'y', gap: 'Z', padding: 'A' },

  SummaryNumbers: {
    flow: 'x',
    gap: 'C',
    align: 'center flex-start',
    '@mobileL': { gap: 'A', flexWrap: 'wrap' },

    TotalFee: {
      flow: 'y',
      gap: 'W',
      TotalLabel: { text: 'Total Fee', fontSize: 'Y', color: 'inkMuted', fontWeight: '500' },
      TotalValue: {
        text: (el, s) => {
          var v = s.totalFee || 3470
          return '₾' + Number(v).toLocaleString()
        },
        fontSize: 'B', fontWeight: '700', color: 'inkText'
      }
    },
    InsuranceEst: {
      flow: 'y',
      gap: 'W',
      InsLabel: { text: 'Insurance Est.', fontSize: 'Y', color: 'inkMuted', fontWeight: '500' },
      InsValue: {
        text: (el, s) => {
          var v = s.insuranceCoverage || s.insuranceEst || 1850
          return '₾' + Number(v).toLocaleString()
        },
        fontSize: 'B', fontWeight: '700', color: 'teal'
      }
    },
    PatientPortion: {
      flow: 'y',
      gap: 'W',
      PatLabel: { text: 'Patient Portion', fontSize: 'Y', color: 'inkMuted', fontWeight: '500' },
      PatValue: {
        text: (el, s) => {
          var v = s.patientPortion || 1620
          return '₾' + Number(v).toLocaleString()
        },
        fontSize: 'B', fontWeight: '700', color: 'inkText'
      }
    }
  },

  SummaryActions: {
    flow: 'x',
    gap: 'Z',
    align: 'center center',
    flexShrink: '0',

    PresentBtn: {
      extends: 'Button',
      text: '{{ presentToPatient | polyglot }}',
      background: 'teal',
      color: 'ink',
      fontWeight: '600',
      padding: 'Z A',
      round: 'A',
      fontSize: 'Z',
      cursor: 'pointer',
      border: 'none'
    },
    PortalBtn: {
      extends: 'Button',
      text: '{{ sendToPortal | polyglot }}',
      background: 'inkSurface',
      color: 'inkText',
      fontWeight: '600',
      padding: 'Z A',
      round: 'A',
      fontSize: 'Z',
      cursor: 'pointer',
      border: '1px solid inkBorder'
    }
  }
}
